import { IAppState } from "../app.state";

export const selectContract = (state: IAppState) => state.contracts;
